module.exports = __webpack_public_path__ + "static/media/gaurav.147d8c03.jpg";